import type {ReactNode} from 'react';

export function NavigationRow({icon,title,detail,onClick,status}:{
  icon:ReactNode;
  title:string;
  detail?:string;
  onClick:()=>void;
  status?:string;
}){
  return <button className="op-list-item" type="button" onClick={onClick}>
    <span className="op-list-icon" aria-hidden="true">{icon}</span>
    <span className="op-list-copy">
      <strong>{title}</strong>
      {detail&&<small style={{whiteSpace:'pre-line',overflowWrap:'anywhere'}}>{detail}</small>}
    </span>
    {status?<span className="op-status">{status}</span>:<span aria-hidden="true">›</span>}
  </button>;
}
